.selected {
  border: 2px solid black;
}

.growShrink {
  position: relative;
  transition: transform 0.22s ease, box-shadow 0.22s ease,
    border-color 0.22s ease, background-color 0.22s ease;
  border-width: 2px;
  border-color: hsl(var(--border));
  background: linear-gradient(
    165deg,
    hsl(var(--card)) 0%,
    hsl(var(--muted) / 0.65) 100%
  );
  box-shadow: 0 3px 10px hsl(220 20% 10% / 0.06);
}

.growShrink:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px hsl(220 20% 10% / 0.1);
}

.growShrink[data-state="on"] {
  transform: scale(1.03);
  border-color: hsl(var(--primary) / 0.85);
  background: linear-gradient(
    160deg,
    hsl(var(--accent) / 0.95) 0%,
    hsl(var(--muted) / 0.55) 100%
  );
  box-shadow: 0 0 0 3px hsl(var(--ring) / 0.25), 0 8px 20px hsl(var(--ring) / 0.2);
}

.wordLabel {
  line-height: 1.15;
  white-space: normal;
  text-wrap: balance;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-height: 2.3em;
}

.tileReveal {
  animation: tile-enter 380ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@keyframes tile-enter {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .growShrink,
  .tileReveal {
    transition: none;
    animation: none;
  }
}
